import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_YELLOW,
    codeProp: 'ooNo',
    detailUrl: '/OoDetail',
    detailIdProp: 'ooId',
    listUrl: '/OoList',
    mapProp: 'ooMap',
    name: '组织对象',
    textProp: 'ooName',
    type: 'OO',
}
